import req from '../http';
import urls from '../../utils/config';
const baseURL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL : urls['url']

// 代驾司机行为分变更记录
export const getBehaviorScoreChangeRecord = params => req('post', '/driver/info/getBehaviorScoreChangeRecord', params, {
  baseURL: baseURL
});

// 代驾司机行为分信息
export const getBehaviorScoreInfo = params => req('post', '/driver/info/getBehaviorScoreInfo', params, {
    baseURL: baseURL
});
